import { Injectable } from "@angular/core"
import { environment } from "../../../../environments/environment"
import { AppService } from "../../../core/services/app.service"
import { HttpClient, HttpParams } from "@angular/common/http"
import {
  CustomURLEncoder,
  isNullOrUndefined,
} from "src/app/core/helpers/http-params-extensions"

@Injectable()
export class ProfileService {
  private get_profile_autocomplete_url: string
  private get_profile_currentRole_url: string
  private get_profile_currentUser_url: string
  private get_profile_currentTenantId_url: string
  private get_profile_paginate_url: string
  private get_account_id_url: string

  private buildUrls(accountUrl: string) {
    this.get_profile_paginate_url =
      accountUrl + environment.endpointAccount.routes.get_profile_paginate
    this.get_profile_autocomplete_url =
      accountUrl + environment.endpointAccount.routes.get_profile_autocomplete
    this.get_profile_currentRole_url =
      accountUrl + environment.endpointAccount.routes.get_profile_currentRole
    this.get_profile_currentTenantId_url =
      accountUrl +
      environment.endpointAccount.routes.get_profile_currentTenantId
    this.get_profile_currentUser_url =
      accountUrl + environment.endpointAccount.routes.get_profile_currentUser
    this.get_account_id_url =
      accountUrl + environment.endpointAccount.routes.get_account_id
  }

  constructor(private httpClient: HttpClient, private appService: AppService) {
    this.buildUrls(environment.endpointAccount.url)
  }

  getCurrentRole() {
    return this.httpClient.get<any>(this.get_profile_currentRole_url)
  }

  getCurrentUserId() {
    return this.httpClient.get<any>(this.get_profile_currentUser_url)
  }

  getCurrentTenantId() {
    return this.httpClient.get<any>(this.get_profile_currentTenantId_url)
  }

  getUserName(userId: string) {
    return this.httpClient.get<any>(
      this.get_account_id_url.replace("{accountId}", userId)
    )
  }

  getPaginate(profile: any) {
    let params = new HttpParams({ encoder: new CustomURLEncoder() })
    if (!isNullOrUndefined(profile.AskPage))
      params = params.set("AskPage", String(profile.AskPage))
    if (!isNullOrUndefined(profile.ItensPerPage))
      params = params.set("ItensPerPage", String(profile.ItensPerPage))
    if (!isNullOrUndefined(profile.OrderByFilter))
      params = params.set("OrderByFilter", String(profile.OrderByFilter))
    if (!isNullOrUndefined(profile.Name))
      params = params.set("Name", String(profile.Name))
    if (!isNullOrUndefined(profile.Description))
      params = params.set("Description", String(profile.Description))
    if (!isNullOrUndefined(profile.IsDesc))
      params = params.set("IsDesc", String(profile.IsDesc))
    return this.httpClient.get<any>(this.get_profile_paginate_url, { params })
  }

  getAutoCompleteProfile(value: string) {
    const params = new HttpParams({ encoder: new CustomURLEncoder() }).set(
      "term",
      value
    )

    return this.httpClient.get<any>(this.get_profile_autocomplete_url, {
      params,
    })
  }

  getUserHelp() {
    const endpointUserHelp =
      environment.endpointUserHelp.url +
      environment.endpointUserHelp.routes.getUserHelp
    return this.httpClient.get<any>(endpointUserHelp)
  }
}
